import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { InvoiceLabelTypeTaxInfo } from 'src/app/model/invoice-label-type-tax-info';

@Injectable({
  providedIn: 'root'
})
export class InvoiceLabelService {

  constructor(  public dataService: DataService ) { }

  private readonly getInvoiceLabelTypeAndTaxEndPoint: string = '/invoiceCashDesk/getInvoiceLabelTypeAndTax/';

  async getInvoiceLabelTypeAndTax(taxpayerTypeId: number): Promise<InvoiceLabelTypeTaxInfo> {
    const params = { taxpayerTypeId: taxpayerTypeId };
    return await this.dataService.get<InvoiceLabelTypeTaxInfo>(this.getInvoiceLabelTypeAndTaxEndPoint, params).toPromise();
  }

}
